export default __webpack_public_path__ + "static/media/p30.f96f2895.jpg";